const refs = 'warning'
export default [
    {
        path: '/',
        redirect: "/home"
    },
    {
        path: '/warning/:code',
        name: 'payment',
        component: () => import('@/views/'+refs+'/index.vue')
    },
]
